import React from 'react'
import { ResponsiveLine } from '@nivo/line'
import styles from './ModelChart.module.scss'

interface IData {
  id: string
  name?: string
  data: {
    x: number | string | Date;
    y: number | string | Date;
  }[]
}

interface Props {
  withLegend?: boolean
  colors: string[]
  data: IData[],
  yMin?: number,
  yMax?: number
}

const ModelChart = ({ data, colors, yMin, yMax, withLegend = false }: Props) => {

  return (
    <div style={{ height: 340, width: '100%' }}>
      <ResponsiveLine
        useMesh
        data={data}
        margin={{ top: withLegend ? 40 : 20, right: 20, bottom: 45, left: 58 }}
        xScale={{ type: 'linear' }}
        yScale={{
          type: 'linear',
          stacked: false,
          min: yMin || 'auto',
          max: yMax || 'auto',
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          orient: 'bottom',
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legends: data[0].id,
          legendOffset: 36,
          legendPosition: 'middle',
          legend: 'months',
        }}
        axisLeft={{
          orient: 'left',
          tickSize: 0,
          tickPadding: 5,
          tickRotation: 0,
          legendOffset: -53,
          legendPosition: 'middle',
          legend: 'people',
          format: (v: any) => typeof v === 'string' ? parseInt(v) : Math.floor(v),
        }}
        curve={'natural'}
        colors={colors}
        enableGridX={false}
        enableGridY={true}
        enablePoints={false}
        legends={withLegend ? [{
          anchor: 'top-left',
          direction: 'row',
          itemWidth: 150,
          itemHeight: 20,
          translateY: -30,
          translateX: -50,
          symbolSize: 12,
          symbolShape: 'circle',
        }] : undefined}
        tooltip={props => tooltip(props, data)}
      />
    </div>
  )
}

const tooltip = (props: any, data: IData[]) => {
  const { point: { serieId, data: { x, y } } } = props
  const serie = data.find(i => i.id === serieId)
  const title = serie && serie.name

  return (
    <div className={styles.tooltip}>
      {title && <div className={styles.title}>{title}</div>}
      <div className={styles.label}>months: <span className={styles.value}>{x}</span></div>
      <div className={styles.label}>people: <span className={styles.value}>{Math.round(y)}</span></div>
    </div>
  )
}

export default ModelChart
